import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Home() {
    const [members, setMembers] = useState([]);
    const [logs, setLogs] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const API_MEMBERS = `${process.env.REACT_APP_BACKEND_URL}/api/members`;
    const API_LOGS = `${process.env.REACT_APP_BACKEND_URL}/api/exercise-logs`;

    const fetchMembers = async () => {
        try {
            const res = await axios.get(API_MEMBERS);
            setMembers(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchLogs = async (pageNum = 1, date = selectedDate) => {
        try {
            const res = await axios.get(`${API_LOGS}?date=${date}&page=${pageNum}`);
            setLogs(res.data.logs);
            setTotalPages(res.data.totalPages);
            setPage(pageNum);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchMembers();
        fetchLogs();
    }, []);

    const handleDateChange = (e) => {
        const newDate = e.target.value;
        setSelectedDate(newDate);
        fetchLogs(1, newDate);
    };

    return (
        <div className="content">
            <h2 className="mb-4">لوحة التحكم</h2>

            <div className="row g-3 mb-4">
                <div className="col-md-4">
                    <div className="card shadow-sm p-3">
                        <h5>الأعضاء</h5>
                        <p className="fs-4 fw-bold">{members.length}</p>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5>سجل التمارين</h5>
                    <input
                        type="date"
                        className="form-control w-auto"
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                </div>

                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <thead>
                        <tr>
                            <th>العضو</th>
                            <th>التمرين</th>
                            <th>الوزن</th>
                            <th>التكرارات</th>
                            <th>التاريخ</th>
                        </tr>
                        </thead>
                        <tbody>
                        {logs.length > 0 ? (
                            logs.map((log) => (
                                <tr key={log.id}>
                                    <td>{log.full_name}</td>
                                    <td>{log.exercise_name}</td>

                                    <td>{log.weight}</td>
                                    <td>{log.reps}</td>
                                    <td>{new Date(log.created_at).toLocaleString()}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    لا توجد بيانات
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-between">
                    <button
                        className="btn btn-outline-secondary"
                        disabled={page === 1}
                        onClick={() => fetchLogs(page - 1, selectedDate)}
                    >
                        السابق
                    </button>
                    <span>صفحة {page} من {totalPages}</span>
                    <button
                        className="btn btn-outline-secondary"
                        disabled={page === totalPages}
                        onClick={() => fetchLogs(page + 1, selectedDate)}
                    >
                        التالي
                    </button>
                </div>
            </div>
        </div>
    );
}
